/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import PropTypes from 'prop-types';
import { inViewForReact } from 'utils/common';
import LazyLoad from 'react-lazy-load';
import InViewObserver from 'components/InViewObserver';
import throttle from 'lodash.throttle';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';

class IframeSection extends React.Component {
  constructor() {
    super();
    this.state = {
      // eslint-disable-next-line no-script-url
      stateSrc: '',
    };
    this.scrollIframeInViewListener = throttle(
      () => this.scrollInViewListener(),
      100,
    );
  }

  sendGA = ({ eventtype, id }) => {
    switch (id) {
      case 'indiatimes_lifestyle_iframe':
        if (eventtype === 'scrollInView') {
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: 'indiatimes_lifestyle ',
          });
        }
        break;
      case 'creditscoreiframe':
        if (eventtype === 'click') {
          analyticsWrapper('ga4', {
            event: 'user_click',
            type: 'et_saver_widget',
            category: 'open',
          });
        } else if (eventtype === 'scrollInView') {
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: 'et_saver_widget',
          });
        }
        break;
      case 'wimbledoniframe':
        if (eventtype === 'click') {
          sendGaThroughProps({
            data: {
              gaCategory: 'Wimbeldon_Widget',
              gaAction: 'click',
              gaLabel: `${
                typeof window !== 'undefined' &&
                window.location &&
                window.location.href
                  ? window.location.href
                  : ''
              }`,
            },
          });
        } else if (eventtype === 'scrollInView') {
          sendGaThroughProps({
            data: {
              gaCategory: 'Wimbeldon_Widget',
              gaAction: 'seen',
              gaLabel: `${
                typeof window !== 'undefined' &&
                window.location &&
                window.location.href
                  ? window.location.href
                  : ''
              }`,
              nonInteraction: true,
            },
          });
        }
        break;

      default:
        break;
    }
  };

  componentDidMount() {
    window.addEventListener('blur', this.onBlur);
    window.addEventListener('scroll', this.scrollIframeInViewListener);
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.onBlur);
    window.removeEventListener('scroll', this.scrollIframeInViewListener);
  }

  scrollInViewListener = () => {
    if (this.iframeRef && inViewForReact(this.iframeRef, 0, true)) {
      if (
        typeof this.sendGA === 'function' &&
        this.props.data &&
        this.props.data.id &&
        (this.props.data.id === 'wimbledoniframe' ||
          this.props.data.id === 'creditscoreiframe' ||
          this.props.data.id === 'indiatimes_lifestyle_iframe')
      ) {
        this.sendGA({ eventtype: 'scrollInView', id: this.props.data.id });
        window.removeEventListener('scroll', this.scrollIframeInViewListener);
      }
    }
  };

  onBlur = () => {
    if (
      document &&
      document.activeElement &&
      document.activeElement.nodeName.toLowerCase() === 'iframe' &&
      this.iframeRef &&
      this.iframeRef === document.activeElement &&
      this.props.data &&
      this.props.data.id &&
      (this.props.data.id === 'wimbledoniframe' ||
        this.props.data.id === 'creditscoreiframe')
    ) {
      if (typeof this.sendGA === 'function')
        this.sendGA({ eventtype: 'click', id: this.props.data.id });
    }
  };

  getIframeHtml = () => {
    const height =
      this.props.data && this.props.data.height ? this.props.data.height : '82';
    const width =
      this.props.data && this.props.data.width ? this.props.data.width : '300';
    const iframeId =
      this.props.data && this.props.data.id ? this.props.data.id : '';
    const border = this.props.data && this.props.data.border;

    if (
      this.props.data.lazyload !== '1' &&
      !this.props.useIframeIntersectionObserver
    ) {
      return (
        <iframe
          ref={ref => {
            this.iframeRef = ref;
          }}
          src={this.props.data.wu}
          title={this.props?.data?.name}
          width={width}
          height={height}
          marginWidth="0"
          marginHeight="0"
          hspace="0"
          vspace="0"
          frameBorder="0"
          scrolling="no"
          align="center"
        />
      );
    }
    if (this.props.useIframeIntersectionObserver) {
      return (
        <>
          <iframe
            ref={ref => {
              this.iframeRef = ref;
            }}
            src={this.state.stateSrc}
            title={this.props?.data?.name}
            width={width}
            height={height}
            marginWidth="0"
            marginHeight="0"
            hspace="0"
            vspace="0"
            frameBorder="0"
            scrolling="no"
            align="center"
            style={border ? { border: ' 1px solid' } : {}}
            id={iframeId}
          />
          <InViewObserver
            inViewCallback={() => {
              this.setState({ stateSrc: this.props.data.wu });
            }}
            viewMargin="1000px 0px 1000px 0px"
          >
            <></>
          </InViewObserver>
        </>
      );
    }
    return (
      <>
        <iframe
          src={this.state.stateSrc}
          title={this.props?.data?.name}
          width="258"
          height="82"
          marginWidth="0"
          marginHeight="0"
          hspace="0"
          vspace="0"
          frameBorder="0"
          scrolling="no"
          align="center"
        />

        <LazyLoad
          debounce={false}
          onContentVisible={() => {
            this.setState({ stateSrc: this.props.data.wu });
          }}
          height="1px"
        >
          <></>
        </LazyLoad>
      </>
    );
  };

  render() {
    const s = this.props.styleObj;
    return (
      <React.Fragment>
        <div className={s.box1}>
          <h2>
            <span>{this.props?.data?.name}</span>
          </h2>
          {this.getIframeHtml()}
          {this.props.data &&
            this.props.data.defaultText && (
              <p className={s.iframe_footer}>{this.props.data.defaultText}</p>
            )}
        </div>
      </React.Fragment>
    );
  }
}

IframeSection.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    wu: PropTypes.string,
    lazyload: PropTypes.string,
  }),
  styleObj: PropTypes.shape({}).isRequired,
  useIframeIntersectionObserver: PropTypes.bool,
};

IframeSection.defaultProps = {
  data: {},
  useIframeIntersectionObserver: false,
};

export default IframeSection;
